module.exports = __webpack_public_path__ + "img/ACTIVE_SESSIONS.98516278.svg";